<!-- eslint-disable vue/multi-word-component-names -->

<script setup>
import { ref } from 'vue';


let items = ref([
    "Anti-Microbial Ureteral Stent (Double J)",
    "Diamond-like Carbon Coated Double J Catheter",
    "Ureteral Catheter",
    "PCNL Dilator",
    "Guide Wire",
    "Amplatz Renal Sheath",
    "Amplatz Type Renal Dilator",
    "Nephrostomy Set"
]);

let images = ref([
    "19.webp",
    "20.webp",
    "21.webp",
    "24.webp",
    "52.webp",
]);



</script>

<template>
   <main class="w-full h-auto my-2">

    <section class="container mx-auto h-auto flex flex-col justify-start items-center">
      <span class="font-bold text-xl">Products / Urology</span>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">
        <div class="w-full h-full col-span-1 flex justify-center items-center" v-for="(item,index) in items" :key="index">
            <div class="w-3 h-3 bg-sky-500 rounded-full"></div>
            <span class="mx-2">{{ item }}</span>
        </div>
      </section>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">

        <a download :href="`/urology/${item}`"  v-for="(item,index) in images" class="w-full h-[250px] rounded-lg col-span-1 flex justify-center items-center" :key="index">
            <img  :src="`/urology/${item}`" class="w-full h-full object-contain " alt="">
        </a>

      </section>

    </section>
  </main>
</template>

<style scoped></style>